import { NgModule } from '@angular/core';
import { RecaptchaEnterpriseService } from './recaptcha-enterprise.service';

@NgModule({
  providers: [RecaptchaEnterpriseService],
})
export class RecaptchaEnterpriseModule {}